@if (activeModal) {
  <div class="modal-header">
    <div>
      <h5 class="modal-title mb-0">{{ 'INDICATOR.RISK_MANAGEMENT' | translate }}</h5>
      <small class="text-muted">
        {{ companyName || match }}
        @if (year) {
          <span> &mdash; {{ year }}</span>
        }
        @if (sector) {
          <span> &mdash; {{ sector }}</span>
        }
      </small>
    </div>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="breakdownTable"></ng-container>
  </div>
} @else {
  <div style="position: relative; top: 0%; left: 1%; width: 97%;">
    <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px;">
      <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">← Back</button>
      <h2 style="margin: 0;">{{ 'INDICATOR.RISK_MANAGEMENT' | translate }}</h2>
    </div>
    @if (match) {
      <div style="margin-bottom: 20px;">
        <div><strong>Tax ID:</strong> {{ match }}</div>
        @if (companyName) {
          <div><strong>Company:</strong> {{ companyName }}</div>
        }
        @if (year) {
          <div><strong>Year:</strong> {{ year }}</div>
        }
        @if (sector) {
          <div><strong>Sector:</strong> {{ sector }}</div>
        }
      </div>
    }
    <ng-container *ngTemplateOutlet="breakdownTable"></ng-container>
  </div>
}


<ng-template #breakdownTable>
  @if (loading) {
    <div class="text-center py-4">
      <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
      <span class="ms-2 text-muted">Loading...</span>
    </div>
  }

  @if (!loading) {
    <div>
      <table class="table table-bordered table-hover table-sm">
        <thead class="table-dark">
          <tr>
            <th>Indicator</th>
            <th>Value</th>
            <th>Band</th>
            <th>Ponderation</th>
            <th>Score Contribution</th>
          </tr>
        </thead>
        <tbody>
          @for (row of breakdown; track row) {
            <tr
            [ngClass]="{
              'table-danger':  row.band === 3,
              'table-warning': row.band === 2,
              'table-success': row.band === 1
            }">
              <td>{{ row.name }}</td>
              <td>{{ row.compareValue | number:'1.2-2' }}</td>
              <td>{{ bandLabel(row.band) }}</td>
              <td>{{ row.ponderation }}</td>
              <td><strong>{{ row.contribution | number:'1.2-2' }}</strong></td>
            </tr>
          }
        </tbody>
        @if (breakdown.length > 0) {
          <tfoot>
            <tr class="table-secondary">
              <td colspan="4"><strong>TOTAL RISK SCORE</strong></td>
              <td><strong>{{ totalScore | number:'1.2-2' }}</strong></td>
            </tr>
          </tfoot>
        }
      </table>
      @if (breakdown.length === 0) {
        <div class="text-center text-muted py-3">
          No indicator results found for this taxpayer.
        </div>
      }
    </div>
  }
</ng-template>
